import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PricingStripeComponent } from './pricing-stripe.component';




@NgModule({
  declarations: [PricingStripeComponent],
  exports: [PricingStripeComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule
  ]
})
export class StripeModule { }
